import {FC, useEffect, useState} from 'react'
import {API_URL, isNotEmpty, toAbsoluteUrl} from '../../../_metronic/helpers'
import axios from 'axios'

const SamanIPGfwd: FC = () => {
  const searchParams = new URLSearchParams(document.location.search)
  const [token, setToken] = useState(searchParams.get('token') || '')
  const [send, setSend] = useState(false)

  useEffect(() => {
    if (!send) {
      getToken()
    }
  }, [])

  useEffect(() => {
    if (send) {
      //window.document.getElementById('go')?.click()
    }
  }, [send])

  const getToken = async () => {
    axios.post(`${API_URL}/payment/fwd/sepipg`, {token: token}).then((response) => {
      setToken(response.data.token || '')
      setSend(true)
    })
  }

  return (
    <>
      <p className=' text-center fs-2x pt-10'>
        <i className={`las la-spinner fs-3x me-5 la-spin text-${send ? 'success' : 'primary'}`}></i>
        {!send && <span className=' text-center fs-2x'>درحال اعتبار سنجی...</span>}
        {send && (
          <span className=' text-center fs-2x'>درحال انتقال به درگاه پرداخت اینترنتی...</span>
        )}
      </p>
      {send && (
        <form
          action='https://sep.shaparak.ir/OnlinePG/OnlinePG'
          className='w-100 p-5 text-center'
          method='post'
          target='_self'
        >
          <input
            type='text'
            id='token'
            name='token'
            value={token}
            onChange={() => {}}
            style={{display: 'none'}}
          />
          <input
            type='text'
            id='getmethod'
            name='getmethod'
            value='true'
            onChange={() => {}}
            style={{display: 'none'}}
          />
          <button type='submit' className='btn btn-success' id='go'>
            اگر منتقل نشدید! اینجا کلیک کنید...
          </button>
        </form>
      )}
    </>
  )
}

export {SamanIPGfwd}
